import Attachment from './Attachment';
import Dragger from './Dragger';
Attachment.Dragger = Dragger;
export default Attachment;
